import React from 'react';

import type { EventId } from '@vlabs/api/luna-api/model/EventId';

import {
  EventDetailsGeneralInfo,
  EventDetailsGeolocation,
} from '@vlabs/monokit/entities/event-details';

interface EventDetailsInfoProps {
  eventId: EventId;
  canReadHandler?: boolean;
  canViewHandlersPage?: boolean;
}

function EventDetailsInfo({
  eventId,
  canReadHandler = true,
  canViewHandlersPage = true,
}: EventDetailsInfoProps): React.JSX.Element {
  return (
    <React.Fragment>
      <EventDetailsGeneralInfo
        canReadHandler={canReadHandler}
        canViewHandlersPage={canViewHandlersPage}
        eventId={eventId}
      />
      <EventDetailsGeolocation eventId={eventId} />
    </React.Fragment>
  );
}

export { EventDetailsInfo };
